import { render, staticRenderFns } from "./base-page.vue?vue&type=template&id=56a296d8&scoped=true&"
import script from "./base-page.vue?vue&type=script&lang=js&"
export * from "./base-page.vue?vue&type=script&lang=js&"
import style0 from "./base-page.vue?vue&type=style&index=0&id=56a296d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a296d8",
  null
  
)

export default component.exports